<template>
  <div class="input-wrapper">
    <label
      :for="inputData.name"
      v-if="data.Text && useLabel"
      :title="data.Text"
      >{{ data.Text }}</label
    >
    <div class="input-dropdown-wrapper">
      <select
        :id="inputData.name"
        :name="inputData.name"
        :required="inputData.required"
        class="input-dropdown"
        :class="{
          'active-placeholder': isFocused || (inputData.value || '').length > 0
        }"
        v-model="inputVal"
        @focus="onFocus"
        @blur="onBlur"
        @change="onChange"
      >
        <option :disabled="inputData.required" value=""></option>
        <option
          v-for="(option, option_index) in data.Options"
          :key="option_index"
          :value="option.Value"
          >{{ option.Text }}</option
        >
      </select>
      <icon icon="caret-down" />
    </div>
  </div>
</template>

<script>
import PreApproveMe from '@/services/PreApproveMe.js'

var refi_subtype_cache = null
var const_subtype_cache = null

export default {
  name: 'InputDropdown',
  components: {},
  props: {
    value: String,
    data: Object,
    parent: Object,
    sectionid: String,
    pageid: String,
    useLabel: {
      type: Boolean,
      default: true
    }
  },
  data: () => {
    return {
      isFocused: false,
      inputData: {
        value: '',
        type: false,
        name: '',
        required: false
      }
    }
  },
  computed: {
    inputVal: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    alert: function(msg) {
      this.$store.commit('openToast', {
        text: msg,
        type: 'warning'
      })
    },
    validate: function(alert) {
      alert = alert === true ? true : false
      this.$emit('input:value', this.inputVal)
      this.inputData.value = this.inputVal
      const parsedValue = PreApproveMe.parseInputValue(this.inputData)
      this.$emit('input:value-parsed', parsedValue)
      if (parsedValue !== false) {
        this.$emit('input:isvalid', true)
      } else {
        this.$emit('input:isvalid', false)
        if (alert && this.inputVal) {
          this.alert(this.data.Text + ' is invalid')
        }
      }
    },
    formValidate: function() {
      if (
        this.$store.getters.getSection(this.sectionid) != null &&
        this.$store.getters.getPage(this.pageid) != null
      )
        this.validate(false) // Change to true to alert
    },
    onType: function() {},
    onFocus: function() {
      this.isFocused = true
      this.$emit('input:isfocused', true)
    },
    onBlur: function() {
      this.isFocused = false
      this.$emit('input:isfocused', false)
    },
    onChange: function() {
      // Wrapping this trigger inside of nextTick appears necessary for inputVal to be read correctly, though I'm not sure why at this point.
      var vm = this
      this.$nextTick(function () {
        this.validate()
        this.$emit('input:change', vm.inputVal)
      })
    }
  },
  created: function() {
    if (this.data.Type) this.inputData.type = this.data.Type
    else this.inputData.type = PreApproveMe.getInputType('MultipleChoice')
    this.inputData.name = this.data.Id
    this.inputData.required = this.data.Required

    if (this.data.Value)
      this.inputVal = this.data.Value

    // if (this.data.Value) {
    //   let fieldValue = this.data.Value
    //   let foundRealValue = false
    //   for (let i = 0; i < this.data.Options.length; i++) {
    //     const currText = this.data.Options[i].Text
    //     const currValue = this.data.Options[i].Value
    //     if (this.data.Value == currValue) {
    //       foundRealValue = true
    //       fieldValue = currValue
    //     } else if (!foundRealValue && this.data.Value == currText) {
    //       // Only match Text if the Value match isn't found
    //       fieldValue = currValue
    //     }
    //   }
    //   this.inputData.value = fieldValue
    //   this.validate()
    // }

    // Validate if pre-filled
    this.$nextTick(function () {
      if (this.value)
        this.validate()
    })

    this.$root.$on('form:validate', this.formValidate)
    this.$root.$on('form:validate-force', this.validate)

    var vm = this
    if (vm.data.Id === 'smart1003_refinance_details_type')
      vm.$root.$on('loantype:change', function (evt) {
        if (evt === 'Refinance') {
          if (refi_subtype_cache !== null) {
            vm.inputVal = refi_subtype_cache
            refi_subtype_cache = null
            vm.onChange()
          }
        }
        else {
          if (refi_subtype_cache === null) {
            refi_subtype_cache = vm.inputVal
            vm.inputVal = ''
            vm.onChange()
          }
        }
      })

    if (vm.data.Id === 'smart1003_construction_details_type')
      vm.$root.$on('loantype:change', function (evt) {
        if (evt === 'Construction') {
          if (const_subtype_cache !== null) {
            vm.inputVal = const_subtype_cache
            const_subtype_cache = null
            vm.onChange()
          }
        }
        else {
          if (const_subtype_cache === null) {
            const_subtype_cache = vm.inputVal
            vm.inputVal = ''
            vm.onChange()
          }
        }
      })
  }
}
</script>

<style scoped lang="scss">
select.input-dropdown {
}
</style>
